import TimerFillIcon from 'assets/ver2/icons/timer-small-fill-icon.svg';
import TimerHHMTIcon from 'assets/ver2/icons/timer-small-hhmt-icon.svg';
import TimerRemoxIcon from 'assets/ver2/icons/timer-small-remox-icon.svg';
import { LogUtil } from 'components/common/LogUtil';
import { PORTAL_NAME_MODAL_DEFINE } from 'components/common/PortalModal/config';
import { METHOD_BANK, METHOD_EWALLET, METHOD_PICKUP } from 'constants';
import useLang from 'hooks/useLang';
import usePortalModal from 'hooks/usePortalModal';
import useTheme from 'hooks/useTheme';
import { isEmpty } from 'lodash';
import React from 'react';
import styled from 'styled-components';
import { ETA_IFRAME_HOST } from '../const';

const LOG = 'ETA';

const useETA = ({
  countryConfig,
  payoutMethod,
  suburbIdSelected,
  cityIdSelected,
  pickupOfficeIdSelected,
  bankIdSelected,
  ewalletIdSelected,
}) => {
  const { locate, isVi } = useLang();
  const { isHHMTTheme, theme } = useTheme();
  const { showPortalModalName } = usePortalModal();

  const { dmList } = countryConfig || {};
  const dm = dmList?.find((item) => item?.code === payoutMethod);
  const { eta } = dm || {};

  const ETAByPayoutMethod = eta?.filter(
    (e) => e?.deliveryMethod === payoutMethod
  );
  const ETAByPickup = !isEmpty(ETAByPayoutMethod)
    ? ETAByPayoutMethod?.find((e) => !e?.pickupOfficeId)
    : null;
  const ETAByPickupOfficeId = !isEmpty(ETAByPayoutMethod)
    ? ETAByPayoutMethod?.find(
        (e) => e?.pickupOfficeId === pickupOfficeIdSelected
      ) || ETAByPickup
    : null;
  const ETAByBank = !isEmpty(ETAByPayoutMethod)
    ? ETAByPayoutMethod?.find((e) => !e?.bankId)
    : null;
  const ETAByBankId = !isEmpty(ETAByPayoutMethod)
    ? ETAByPayoutMethod?.find((e) => e?.bankId === bankIdSelected) || ETAByBank
    : null;
  const ETAByEwallet = !isEmpty(ETAByPayoutMethod)
    ? ETAByPayoutMethod?.find((e) => !e?.ewalletId)
    : null;
  const ETAByEwalletId = !isEmpty(ETAByPayoutMethod)
    ? ETAByPayoutMethod?.find((e) => e?.ewalletId === ewalletIdSelected) ||
      ETAByEwallet
    : null;
  const ETAByHome = !isEmpty(ETAByPayoutMethod)
    ? ETAByPayoutMethod?.find((e) => !e?.suburbId && !e?.cityId)
    : null;
  const ETAByHomeBySuburbId = !isEmpty(ETAByPayoutMethod)
    ? ETAByPayoutMethod?.find(
        (e) => e?.suburbId === suburbIdSelected && e?.cityId !== cityIdSelected
      )
    : null;
  const ETAByHomeByCityId = !isEmpty(ETAByPayoutMethod)
    ? ETAByPayoutMethod?.find(
        (e) => e?.suburbId !== suburbIdSelected && e?.cityId === cityIdSelected
      )
    : null;
  const ETAByHomeBySuburbIdAndCityId = !isEmpty(ETAByPayoutMethod)
    ? ETAByPayoutMethod?.find(
        (e) => e?.suburbId === suburbIdSelected && e?.cityId === cityIdSelected
      ) ||
      ETAByHomeBySuburbId ||
      ETAByHomeByCityId ||
      ETAByHome
    : null;

  const currentETA =
    payoutMethod === METHOD_PICKUP
      ? ETAByPickupOfficeId
      : payoutMethod === METHOD_BANK
      ? ETAByBankId
      : payoutMethod === METHOD_EWALLET
      ? ETAByEwalletId
      : ETAByHomeBySuburbIdAndCityId;
  const { url, message } = currentETA || {};
  LogUtil.log(LOG, `currentETA`, currentETA);

  const getIframeSrc = () => {
    if (isVi) return `${ETA_IFRAME_HOST[theme]}/${locate}${url}`;
    return `${ETA_IFRAME_HOST[theme]}${url}`;
  };

  const getMessage = () => {
    if (!message) return '';
    return message?.[locate];
  };

  const handleOnShowETAIframeModal = () => {
    showPortalModalName({
      name: PORTAL_NAME_MODAL_DEFINE.ETA_IFRAME_MODAL,
      modalStyles: {
        width: '866',
        borderRadius: 12,
      },
      modalOptions: {
        iframeSrc: getIframeSrc(),
      },
    });
  };

  const renderSpecificETAInformation = () => {
    const className = url ? 'hyperlink' : '';
    const onClick = url ? handleOnShowETAIframeModal : () => {};
    const iconSrc = url
      ? isHHMTTheme
        ? TimerFillIcon
        : TimerFillIcon
      : isHHMTTheme
      ? TimerHHMTIcon
      : TimerRemoxIcon;

    return (
      <PayoutDesc
        className={className}
        style={{ display: isEmpty(getMessage()) && 'none' }}
        onClick={onClick}
      >
        <img src={iconSrc} alt="" /> {getMessage()}
      </PayoutDesc>
    );
  };

  return { renderSpecificETAInformation };
};

const PayoutDesc = styled.p`
  font-family: var(--ff-primary);
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 20px;
  color: #0e1012;

  display: flex;
  align-items: start !important;
  padding: 0;
  margin: 0;
  margin-bottom: 16px;

  & img {
    margin-right: 4px;
  }

  &.hyperlink {
    color: var(--ds-c-green-default);
    cursor: pointer;

    & img {
      filter: var(--ds-f-c-green);
    }
  }
`;

export default useETA;
